import React from 'react'
import { Box, Container, Stack, Typography } from '@mui/material'
import ApartmentIcon from '@mui/icons-material/Apartment';
import { customStyles, spaceBetween } from '../../../styles';
import { LightText } from '../../helpers';
import { SecondaryText } from '../../helpers/text/SecondaryText';

const style = {
   color: customStyles.colors.main
}
export const PreviewStackContainer = ({ text, children, direction }) => {
  return (
   <Box mt={2} mb={1} sx={{ backgroundColor: customStyles.colors.backgroundColor, boxShadow: customStyles.shadows.light, padding: 1, borderRadius: 2 }}>
      <Typography component="h2" variant="h6"  mb={3}>{ text }</Typography>
      <Stack direction={ direction ? direction : 'row'} spacing={2}>
         { children }
      </Stack>
   </Box>
  )
}
